import { InfoObject, WeatherData } from '../../../Components/AxCalendar/AxCalendar';
import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { CalendarDataInit, SubCCalendar, TimeSlotInfo } from '../Abstraction/SubCCalendar';

@ModuleName("AxProdSelectionCalendar")
export class AxProdSelectionCalendar extends SubCCalendar implements AxInit {

    private ProjNr: number;
    private PoolNr: number;
    private TicketTypeNr: number;

    private Lang: string;
    private PersonTypes: any;

    constructor() { super(); }

    AxInit(initData: CalendarDataTicket) {
        this.ProjNr = initData.ProjNr;
        this.PoolNr = initData.PoolNr;
        this.TicketTypeNr = initData.TicketTypeNr;

        this.Lang = initData.Lang;
        this.PersonTypes = initData.PersonTypes;

        this.Init(initData);

        this.ProductSelection.SubmitSubject.subscribe(x => {
            $('.prod_selection__form').submit();
        });
    };

    LoadTickets(month: number, year: number) {
        //let that = this;
        this.LoadingTickets = true;

        //AxessViewer.ajaxRequest('/api/TicketsV4TimeSlotApi/GetTimeSlotsForCalendar', {
        AxessViewer.ajaxRequest('/api/TicketsV4TimeSlotApi/GetReservationTimeSlotsForCalendar', {
            'ProjNr': this.ProjNr,
            'ProductGroupIdentifier': this.PoolNr,
            'Id': this.TicketTypeNr,
            'Month': month,
            'Year': year,
            'CiUppercase': this.Lang,
            'SubTypeIdentifiers': this.PersonTypes,
            'Type': 0
        }, (resp) => {
            let dt: moment.Moment = moment(year + '-' + month + '-01', "YYYY-MM-DD");
            let dtEnd: moment.Moment = moment(dt).endOf('month');

            for (var m = moment(dt); m.diff(dtEnd, 'days') <= 0 && dt.format('MM') == m.format('MM'); m.add(1, 'days')) {
                let day = resp.find(x => x.ValidFrom == m.format("YYYY-MM-DD"));
                let cont: TimeSlotInfo[] = [];
                let contNum: number = 0;
                if (day != null && typeof day != 'undefined' && typeof day.TimeSlotInfo != 'undefined' && day.TimeSlotInfo?.length > 0) {
                    cont.push(day.TimeSlotInfo);
                    contNum = day.TimeSlotInfo[0].AvailableSlots;
                }
                let weatherData: WeatherData = null;

                if (day != null && typeof day != 'undefined' && day.WeatherData != null) {
                    weatherData = {
                        classNo: day.WeatherData.ClassNo,
                        minTemp: day.WeatherData.MinTemp,
                        maxTemp: day.WeatherData.MaxTemp
                    };
                }

                if (day != null && (contNum > 0 || day.TimeSlotInfo?.length === 0)) {

                    let infoObject: InfoObject = {
                        Date: day.ValidFrom,
                        Price: day.Tariff,
                        AdditionalCellClass: '',
                        OnClick: this.ActivateDaySub,
                        ParentScope: this,
                        ActiveClass: 'axc__row_inner--active',
                        Currency: this.Currency,
                        WeatherData: weatherData
                    };
                    this.Calendar.addInfo(infoObject);
                    this.ProductList.push({
                        Date: day.ValidFrom,
                        Products: day.Products,
                        TimeSlotInfo: day.TimeSlotInfo
                    });
                } else {
                    let infoObject: InfoObject = { Date: m.format("YYYY-MM-DD"), Price: 0, ParentScope: this };
                    this.Calendar.addInfo(infoObject);
                    this.Calendar.addCellClass(m.format("YYYY-MM-DD"), 'allotment__notificiation--off');
                }
            }
            this.UpdatePrice(true);
            this.LoadingTickets = false;

            if (this.NextLoadRequested) {
                this.NextLoadRequested = false;
                this.Calendar.next(true);
            }
        }, {
            type: 'POST'
        });
    }
}

export interface CalendarDataTicket extends CalendarDataInit {
    PoolNr: number;
    TicketTypeNr: number;
    PersonTypes: any;
}
